<div
  role="status"
  class="w-full h-full items-center justify-center"
  *ngIf="isLoadingTimeline"
>
  <svg
    aria-hidden="true"
    class="w-10 h-10 2xl:w-12 2xl:h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#141F58] items-center justify-center mx-auto"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>
</div>


<!-- PLACEHOLDER TIMELINE - When NO data exists -->

<div class="flex flex-col h-full justify-center relative" *ngIf="!hasForecastData && !hasActualData && !isLoadingTimeline && timelineEvolution.length">
  
  <!-- No data message -->
  <div class="absolute inset-0 flex items-center top-4 2xl:top-7 justify-center pointer-events-none h-full z-20">
    <p class="text-gray-400 font-medium text-[0.7rem] 2xl:text-[0.75rem] 3xl:text-[0.8rem] bg-sky-100 px-4 py-2 rounded-sm mb-5">Non ci sono dati da mostrare</p>
  </div>

  <!-- Timeline Container - PLACEHOLDER -->
  <div class="relative px-2 h-full bottom-3 2xl:bottom-0">
    <div class="overflow-x-hidden">
      <ol class="flex-row items-start justify-start pb-4 relative inline-flex min-w-full">
        <!-- Continuous horizontal timeline -->
        <div class="absolute left-0 right-0 top-[25px] 2xl:top-[32px] h-[2px] bg-gray-100 dark:bg-gray-500 z-0"></div>
        
        <li
          *ngFor="let pointInTime of timelineEvolution; let i = index; let isFirst = first"
          class="relative min-w-[140px] 2xl:min-w-[160px] flex-shrink-0 flex flex-col px-2 2xl:px-2.5 z-10"
        >
          <!-- DATE -->
          <div class="flex flex-col items-start mb-3 2xl:mb-4 w-full relative">
            <time
              class="text-[0.6rem] 2xl:text-[0.7rem] font-bold text-gray-200 dark:text-gray-200 whitespace-nowrap mb-1 bg-white dark:bg-gray-900 pr-1 relative z-20"
              [ngClass]="isFirst ? 'ml-[-8px] 2xl:ml-[-10px]' : 'ml-[-19px]'"
            >
              {{ pointInTime.datePoint.split('-').reverse().join('-') }}
            </time>
            
            <!-- Small vertical connector -->
            <div class="w-[2px] h-1.5 2xl:h-3 bg-gray-100 relative z-20"></div>
          </div>
        </li>
      </ol>
    </div>
  </div>
</div>

<!-- SCROLLING BUTTONS -->
<div 
class="absolute z-11 w-[97.5%] h-12 bg-transparent top-[60px] xl:top-[64px] 2xl:top-[82px]">
<div 
*ngIf="!isLoadingTimeline"
class="w-full h-full flex flex-row justify-between items-center">
  <!-- PREV Button -->
  <button   
    [disabled]="currentIndex === 0"
    (click)="prev()"
    [class.opacity-0]="currentIndex === 0"
    [class.pointer-events-none]="currentIndex === 0"
    class="relative right-1 top-0 2xl:top-[1px] transition-all duration-100 bg-white border-2 border-gray-200 hover:bg-slate-100 rounded-full p-1.5 cursor-pointer flex items-center justify-center">
    <svg 
      class="w-[10px] h-[10px] 2xl:w-[14px] 2xl:h-[14px] mr-[1px] 2xl:mr-0.5"
      width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 15L7.5 10L12.5 5" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg> 
  </button>
  
  <!-- NEXT Button -->
  <button 
    (click)="next()"
    [disabled]="currentIndex >= maxIndex"
    [class.opacity-0]="currentIndex >= maxIndex"
    [class.pointer-events-none]="currentIndex >= maxIndex"
    class="relative left-1 top-0 2xl:top-[1px] transition-all duration-100 bg-white border-2 border-gray-200 hover:bg-slate-100 rounded-full p-1.5 cursor-pointer flex items-center justify-center">
    <svg 
      class="w-[10px] h-[10px] 2xl:w-[14px] 2xl:h-[14px] ml-[1px] 2xl:ml-0.5"
      width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 5L12.5 10L7.5 15" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button> 
</div>
</div>

<!-- REAL TIMELINE - When data exists -->
<div class="flex flex-col h-full justify-center" *ngIf="(hasForecastData || hasActualData) && !isLoadingTimeline && timelineEvolution.length">

  <!-- Timeline Container - WITH DATA -->
  <div class="relative px-2 h-full bottom-3 2xl:bottom-0">
    <div class="overflow-x-hidden scroll-smooth [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]" #carouselEvolutionRegionalAccess>
      <ol class="flex-row items-start justify-start pb-4 relative inline-flex min-w-full">
        <!-- Continuous horizontal timeline -->
        <div class="absolute left-0 right-0 top-[25px] 2xl:top-[32px] h-[2px] bg-gray-200 dark:bg-gray-500 z-0"></div>
        
        <li
          *ngFor="let pointInTime of timelineEvolution; let i = index; let isLast = last; let isFirst = first"
          class="relative w-[144px] xl:w-[148px] 2xl:w-[160px] flex-shrink-0 flex flex-col px-2 2xl:px-2.5 z-10 pointInTimeline"
        >
          <!-- DATE -->
          <div class="flex flex-col items-start mb-3 2xl:mb-4 w-full relative">
            <time
              class="text-[0.6rem] 2xl:text-[0.7rem] font-bold text-gray-600 dark:text-gray-200 whitespace-nowrap mb-1 bg-white dark:bg-gray-900 pr-1 relative z-20"
                [ngClass]="(isFirst || i === currentIndex) ? 'ml-[-8px] 2xl:ml-[-10px]' : 'ml-[-19px]'"

            >
              {{ pointInTime.datePoint.split('-').reverse().join('-') }}
            </time>
            
            <!-- Small vertical connector -->
            <div class="w-[2px] h-1.5 2xl:h-3 bg-gray-200 relative z-20"></div>
          </div>

          <!-- FORECAST Section (TOP) - Fixed height -->
          <div *ngIf="hasForecastData" class="flex flex-col items-center mb-3 2xl:mb-4 h-[68px] 2xl:h-[105px]">
            <div *ngIf="pointInTime.forecast.length" class="w-full h-full">
              <div class="bg-[#00cebd08] dark:bg-gray-800 rounded-lg p-2 relative right-1 2xl:p-2.5  border-1 border-gray-200  transition-all h-full flex flex-col">
                <div class="flex-1 overflow-y-auto scrollbarForRegions space-y-0.5">
                  <p
                    *ngFor="let region of pointInTime.forecast"
                    class="text-[0.5rem] 2xl:text-[0.7rem] text-dimot-secondary dark:text-gray-300 leading-relaxed"
                  >
                    {{
                      region === "Prov. Aut. di Trento"
                        ? "PA Trento"
                        : region === "Prov. Aut. di Bolzano"
                        ? "PA Bolzano"
                        : region === "Friuli Venezia Giulia"
                        ? "Friuli V G"
                        : region === "Emilia-Romagna" && timelineEvolution.length > 7
                        ? "Emilia R"
                        : region === "Valle D'Aosta" && timelineEvolution.length > 7
                        ? "V D'Aosta"
                        : region
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- ACTUAL Section (BOTTOM) - Fixed height -->
          <div *ngIf="hasActualData" class="flex flex-col items-center h-[68px] 2xl:h-[105px]">
            <div *ngIf="pointInTime.actual.length" class="w-full h-full">
              <div class="bg-[#002aff08] dark:bg-gray-800 rounded-lg p-2 relative right-1 2xl:p-2.5 border-1 border-gray-200 transition-all h-full flex flex-col">
                <div class="flex-1 overflow-y-auto scrollbarForRegions space-y-1 2xl:space-y-0.5">
                  <p
                    *ngFor="let region of pointInTime.actual"
                    class="text-[0.5rem] 2xl:text-[0.7rem] text-dimot-1 dark:text-gray-300 leading-relaxed"
                  >
                    {{
                      region === "Prov. Aut. di Trento"
                        ? "PA Trento"
                        : region === "Prov. Aut. di Bolzano"
                        ? "PA Bolzano"
                        : region === "Friuli Venezia Giulia"
                        ? "Friuli V G"
                        : region === "Emilia-Romagna" && timelineEvolution.length > 7
                        ? "Emilia R"
                        : region === "Valle D'Aosta" && timelineEvolution.length > 7
                        ? "V D'Aosta"
                        : region
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ol>
    </div>
  </div>
</div>